/**
 * Converts a string to a slug-like form: spaces become hyphens, lowercased.
 * Useful for generating IDs from labels (e.g. "Email Address" → "email-address").
 */
export function slugify(value: string): string {
  return value.replace(/\s+/g, '-').toLowerCase();
}
